export default __webpack_public_path__ + "static/media/brand13.f0f94dee.svg";